// extracted by mini-css-extract-plugin
export default {"feedbackBanner":"PromptFeedbackBanner-module__feedbackBanner--qYMLR"};